<template>
  <div class="contents">
    <div class="container">
      <div v-if="title || $slots.actions" class="row">
        <div class="col-lg-12">
          <div
            class="breadcrumb-main"
            :class="{ 'justify-content-sm-between': $slots.actions }"
          >
            <div class="d-flex flex-wrap breadcrumb-main__wrapper">
              <div class="d-flex align-items-center user-member__title">
                <h4 class="text-capitalize fw-500 breadcrumb-title">{{ title }}</h4>
              </div>
              <p v-if="subtitle" class="page-subtitle w-100">{{ subtitle }}</p>
            </div>
            <div v-if="$slots.actions" class="action-btn">
              <slot name="actions" />
            </div>
          </div>
        </div>
      </div>

      <slot name="alert" />

      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageLayout',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
}
</script>
